var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96793 5.91925C5.11127 6.3295 4.3079 6.87211 3.58252 7.53709L3.43047 7.67647C3.30752 7.78918 3.30046 7.98954 3.41514 8.11176L4.46959 9.23558C4.57194 9.34466 4.7356 9.3521 4.84629 9.25271L4.97692 9.13542C5.76326 8.42935 6.66167 7.90274 7.62354 7.57503L5.96793 5.91925Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66412 8.61572C7.66257 8.83624 6.72079 9.30287 5.909 9.98877L5.74539 10.127C5.61482 10.2373 5.60363 10.4443 5.72146 10.5699L6.77911 11.6971C6.87726 11.8017 7.03267 11.8134 7.14365 11.7245L7.27275 11.6212C8.06169 10.9894 9.01541 10.6502 10.0074 10.6502C10.2633 10.6502 10.5167 10.6728 10.7653 10.7171L8.66412 8.61572Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3462 11.5501L10.2718 8.47541C11.6646 8.53409 12.9941 9.05561 14.0893 9.97492L14.2538 10.113C14.385 10.2232 14.3965 10.4306 14.2784 10.5565L13.3462 11.5501Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04017 7.24368L7.22203 5.42535C8.11753 5.14505 9.05404 5 10.0074 5C12.3697 5 14.6287 5.89057 16.4168 7.52295L16.5694 7.66228C16.6928 7.77488 16.7 7.97558 16.5852 8.09798L15.5306 9.22195C15.4284 9.33085 15.2651 9.33848 15.1544 9.23953L15.0238 9.12284C13.616 7.86472 11.8514 7.18036 10.0074 7.18036C9.68199 7.18036 9.35908 7.20167 9.04017 7.24368Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6994 12.428C11.1871 12.1075 10.6057 11.9395 10.0074 11.9395C9.40111 11.9395 8.81232 12.112 8.29532 12.4406L8.09008 12.571C7.93405 12.6701 7.90727 12.8993 8.03573 13.0362L9.79658 14.9129C9.90544 15.0289 10.0819 15.0289 10.1908 14.9129L11.963 13.0241C12.092 12.8866 12.0644 12.6562 11.907 12.5578L11.6994 12.428Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31104 2.92891L2.18343 2.05326L17.8084 17.6799L16.9352 18.5547L1.31104 2.92891Z",
    fill: "#FF7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiFailed);
export default __webpack_public_path__ + "static/media/wifi_failed.6c602d3ac72344ed7f29b8e6be94406c.svg";
export { ForwardRef as ReactComponent };